import { useCallback, useMemo } from "react";
import { useQuery } from "@apollo/client";

import { UserGuideCertification } from "types/generated";
import useIsOnboardingCertificatesAvailable from "hooks/useIsOnboardingCertificatesAvailable";

import { GET_USER_GUIDE_CERTIFICATION_LIST } from "./gql";

export type Certificate = Pick<
  UserGuideCertification,
  "id" | "groupID" | "course" | "displayName" | "issuedAt"
>;

const EMPTY: Certificate[] = [];

const useUserGuideCertificates = () => {
  const isOnboardingCertificatesAvailable = useIsOnboardingCertificatesAvailable();
  const { data, loading, error } = useQuery(GET_USER_GUIDE_CERTIFICATION_LIST, {
    skip: !isOnboardingCertificatesAvailable,
  });

  const certificates = useMemo<Certificate[]>(
    () => data?.userGuideCertificationList ?? EMPTY,
    [data]
  );

  const getCertificateByGroupId = useCallback(
    (groupId: string): Certificate | undefined => certificates.find((c) => c.groupID === groupId),
    [certificates]
  );

  return { certificates, loading: loading && !data, error, getCertificateByGroupId };
};

export default useUserGuideCertificates;
